import tunnel from 'tunnel-rat';

// Single tunnel used to portal R3F scene contents from any route into the
// app-wide PersistentCanvas. Keeping the Canvas mounted for the whole app
// lifecycle prevents the iOS Safari WebGL context exhaustion / GPU memory
// pile-up that caused crashes after a few route switches.
export const sceneTunnel = tunnel();
